import { injectable } from 'tsyringe';
import {
  IOWWrapper,
  IPlatform,
} from 'app-core/src/interfaces/ow-wrappers/ow-wrapper.interface';

// -----------------------------------------------------------------------------
@injectable()
export class OWWrapper implements IOWWrapper {
  // ---------------------------------------------------------------------------
  getHostAppUid(): string {
    return '';
  }

  // ---------------------------------------------------------------------------
  public getPlatform(): IPlatform {
    return 'ow';
  }

  // ---------------------------------------------------------------------------
  public getVersion(): string {
    return overwolf.version;
  }
}
